import ProductCards from './ProductCards';

interface HomeProductsProps {
  products: any[];
  totalProducts: number;
  addProductToCart: (id: string) => Promise<void>;
  removeProductFromCart: (id: string) => Promise<void>;
}

const HomeProducts = (props: HomeProductsProps) => {
  const { products, addProductToCart, removeProductFromCart } =
    props;

  return (
    <>
      {products.map((product: any, index: number) => (
        <div key={index} className="flex flex-col h-full">
          <ProductCards
            product={product}
            addProductToCart={addProductToCart}
            removeProductFromCart={removeProductFromCart}
            isAccessories={false}
            allowedProduct={product?.allowedProducts?.length}
          />
        </div>
      ))}
    </>
  );
};

export default HomeProducts;
